"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var input_checkbox_1 = require("../../components/input/input.checkbox");
var theme_1 = require("../../components/theme");
var tag_card_checkbox_style_1 = require("../tag.card.checkbox/tag.card.checkbox.style");
exports.CSS = {
    container: 'c-CollectionCard',
    containerLeft: 'c-CollectionCard__left',
    noLocation: 'c-CollectionCard--no-loc',
    link: 'c-CollectionCard__link',
    info: 'c-CollectionCard__info',
    filterMatch: 'c-CollectionCard__match',
    isHovered: 'c-CollectionCard--is-hovered',
    isInspected: 'c-CollectionCard--is-inspected',
    isSubtitle: 'c-CollectionCard__is-subtitle'
};
var CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 2;
var CIRCLE_SIZE_PX = CIRCLE_RADIUS * 2 + 'px';
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex',
        'align-items': 'center',
        'padding-left': theme_1.DefaultTheme.space(3),
        cursor: 'pointer',
        'border-left': "".concat(theme_1.DefaultTheme.space(1), " solid transparent"),
        '&:hover': {
            backgroundColor: theme_1.DefaultTheme.font.color.divider
        }
    },
    _a[exports.CSS.noLocation] = {
        color: theme_1.DefaultTheme.font.color.disabled,
        cursor: 'default'
    },
    _a[exports.CSS.link] = {
        flex: '1',
        'padding-left': theme_1.DefaultTheme.space(3),
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    _a[exports.CSS.filterMatch] = {
        fontWeight: theme_1.DefaultTheme.font.weight.bold
    },
    _a[exports.CSS.isSubtitle] = {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[exports.CSS.info] = {
        flex: '1',
        color: theme_1.DefaultTheme.font.color.disabled,
        'font-size': '90%',
        'padding-right': theme_1.DefaultTheme.space(1),
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis',
        'text-align': 'right'
    },
    _a[exports.CSS.isHovered] = {
        'background-color': theme_1.DefaultTheme.font.color.hover
    },
    _a[exports.CSS.isInspected] = {
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        'border-color': theme_1.DefaultTheme.color.accent
    },
    _a["".concat(exports.CSS.container, " .").concat(tag_card_checkbox_style_1.CSS.container)] = {
        width: CIRCLE_SIZE_PX,
        height: CIRCLE_SIZE_PX
    },
    _a["".concat(exports.CSS.container, " .").concat(input_checkbox_1.CSS.container, " i")] = {
        'font-size': CIRCLE_SIZE_PX
    },
    _a);
//# sourceMappingURL=collection.card.style.js.map